import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    message,
    Modal,
    Radio,
    Row,
    Select,
    Spin,
    Tooltip,
    Upload
} from "antd";
import React, {useEffect, useState} from "react";
import {transfer_template_img, transfer_title_img} from '../../../../AppImageConst';
import {DownloadOutlined, ExclamationCircleOutlined, InfoCircleOutlined, PlusOutlined} from "@ant-design/icons";
import '../../customerTemplates/style.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBank, faUser} from "@fortawesome/free-solid-svg-icons";
import customerService from "../../../service/customerService";
import ErrorHandler from "../../../util/ErrorHandler";
import {CustomerDto} from "../../../dto/CustomerDto";
import transactionFetchService from "../../../service/transactionFetchService";
import {
    INSUFFICIENT_AMOUNT,
    INVALID_AMOUNT,
    LIMIT_YOUR_INPUT,
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_ENTER_PORTFOLIO_ID,
    MSG_ENTER_VALID_PORTFOLIO_ID,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_CIN_LIST_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR,
    MSG_FAILED_TO_FETCH_FUND_LIST_ERROR,
    MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR,
    MSG_TRANSFER_FAILURE,
    MSG_TRANSFER_SUCCESS,
    PLEASE_ENTER_AMOUNT,
    PLEASE_ENTER_TRANSFERABLE_AMOUNT
} from "../../../util/Messages";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import Validation from "../../../util/Validation";
import {toNumber} from "lodash";
import CommonFunction from "../../../util/CommonFunction";
import {TransactionTemplateDto} from "../../../dto/TransactionTemplateDto";
import {DefaultDocumentDto} from "../../../dto/DefaultDocumentDto";
import {TransactionSummaryDto} from "../../../dto/TransactionSummaryDto";
import {
    ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPE_EXTENSION,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES,
    AMOUNT_VALIDATION,
    DIGITS_AND_DOT_VALIDATION,
    DOCUMENT_TYPES,
    PREVIEW_DOC_TYPES,
    TRANSACTION_SUMMARY_PAGE_TYPES
} from "../../../util/Constants";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import modal from "antd/es/modal";
import transactionService from "../../../service/transactionService";
import PreviewModalComp from "../../../components/common/preview/PreviewModalComp";
import TransactionSummaryPage from "./transactionSummaryPage";

enum ACCOUNT_TYPE {
    OWN = "OWN",
    OTHER = "OTHER",
}

const TransferRequestPage = () => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;

    const [form] = Form.useForm();

    const [transferAccountType, setTransferAccountType] = useState<ACCOUNT_TYPE>(ACCOUNT_TYPE.OWN);
    const [isSpinning, setSpinning] = useState<boolean>(false);
    const [cinNumber, setCinNumber] = useState<string | null>();
    const [jobNumber, setJobNumber] = useState<number>(0)
    const [portfolioList, setPortfolioList] = useState<DropdownListDto[]>([]);
    const [fundList, setFundList] = useState<DropdownListDto[]>([]);
    const [selectedPortfolioId, setSelectedPortfolioId] = useState<number>(0);
    const [isDocumentUploadMandatory, setDocumentUploadMandatory] = useState<boolean>(false);
    const [isSelectFullAmountDisabled, setSelectFullAmountDisabled] = useState<boolean>(true);
    const [transferFundAmount, setTransferFundAmount] = useState<number>(0);
    const [isSelectFullAmountSelected, setSelectFullAmountSelected] = useState<boolean>(false);
    const [isToPortfolioDisabled, setToPortfolioDisabled] = useState<boolean>(true);
    const [uploadDocumentDetailId, setUploadDocumentDetailId] = useState<number>()
    const [uploadedDocumentList, setUploadedDocumentList] = useState<DefaultDocumentDto[]>()
    const [isCanHideSummery, setCanHideSummery] = useState<boolean>(true);
    const [summaryData, setSummaryData] = useState<TransactionSummaryDto>({} as TransactionSummaryDto);
    const [toPortfolioId, setToPortfolioId] = useState<number>();
    const [toPortfolioCustomerName, setToPortfolioCustomerName] = useState<string>();
    const [cinDataList, setCinDataList] = useState<DropdownListDto[]>([]);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');


    const handleTransferAccountTypeRadioChange = (value: any) => {
        let checkBoxValue = value.target.value;
        setTransferAccountType(checkBoxValue);
        form.setFieldsValue({accountType: checkBoxValue})
        form.resetFields(["toPortfolioId", "otherPortfolioName", "otherToPortfolioId"])
    };


    useEffect(() => {
        form.setFieldsValue({accountType: ACCOUNT_TYPE.OWN})
    }, [])


    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".pdf, .jpeg, .jpg, .png"
    };

    const fetchCustomerDetailsByCIN = (cinNumber: string) => {
        customerService.getExactCustomerByCin(cinNumber).then(res => {
            if (res.data.results.customerMstDto != null) {
                const customerDto = res.data.results.customerMstDto as CustomerDto
                setJobNumber(customerDto.id as number)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const fetchFundList = (portfolioId: number) => {
        setSpinning(true)
        transactionFetchService.getFundListForSwitchTransferAndWithdrawal(portfolioId).then(res => {
            if (res.data !== null) {
                setFundList(res.data.results)
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_LIST_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }
    const fetchPortfolioList = (cinNumber: string) => {
        if (null != cinNumber) {
            setSpinning(true)
            transactionFetchService.getPortfolioListForSwitchTransferAndWithdrawal(cinNumber).then(res => {
                if (res.data !== null) {
                    setPortfolioList(res.data.results)
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    const checkDocumentUploadMandatory = (portfolioId: number, cinNumber: string | null | undefined) => {
        if (cinNumber) {
            setSpinning(true)
            transactionFetchService.checkPortfolioJointAndOperatingInstructionsBothParties(portfolioId, cinNumber).then(res => {
                if (res.data !== null) {
                    setDocumentUploadMandatory(res.data.results)
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR).then();
                    setSpinning(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)

            })
        }
    }

    const onChangePortfolio = (value: number) => {
        setSelectedPortfolioId(value)
        fetchFundList(value)
        setToPortfolioDisabled(false)
        checkDocumentUploadMandatory(value, cinNumber)
        resetFrom()
    }

    const resetFrom = () => {
        form.resetFields(["transferAmount", "accountType", "fullAmount", "fundId", "toPortfolioId", "otherPortfolioName", "documentUpload"])
        form.setFieldsValue({accountType: ACCOUNT_TYPE.OWN})
        setTransferAccountType(ACCOUNT_TYPE.OWN)
        setSelectFullAmountDisabled(true)
        setSelectFullAmountSelected(false)

    }

    const onChangeFund = (value: number) => {
        fetchAvailableAmount(selectedPortfolioId, value)
    }

    const onChangeToPortfolio = (value: number) => {

    }

    const convertToValue = (value: number) => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }
    const fetchAvailableAmount = (portfolioId: number, fundId: number) => {
        if (0 != portfolioId && 0 != fundId) {
            setSpinning(true)
            transactionFetchService.getAvailableBalance(portfolioId, fundId).then(res => {
                if (res.data !== null) {
                    let amount = res.data.results;
                    setTransferFundAmount(amount)
                    form.setFieldsValue({fullAmount: convertToValue(amount)})
                    form.resetFields(['transferAmount'])
                    setSelectFullAmountSelected(false)
                    if (amount > 0) {
                        setSelectFullAmountDisabled(false)
                    } else {
                        setSelectFullAmountDisabled(true)
                    }
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_FUND_AMOUNT_ERROR).then();
                    setSpinning(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)

            })
        }
    }

    const onSelectFullAmount = (evt: CheckboxChangeEvent) => {
        setSelectFullAmountSelected(evt.target.checked)
        if (evt.target.checked) {
            form.setFieldsValue({transferAmount: convertToValue(transferFundAmount)})
        } else {
            form.resetFields(["transferAmount"])
        }
    }
    const validateAmount = (_: any, value: any) => {
        if (!value) {
            return Promise.reject(PLEASE_ENTER_AMOUNT);
        } else if (toNumber(CommonFunction.removeThousandSeparators(value)) <= 0) {
            return Promise.reject(PLEASE_ENTER_TRANSFERABLE_AMOUNT);
        } else if (toNumber(transferFundAmount) < toNumber(CommonFunction.removeThousandSeparators(value))) {
            return Promise.reject(INSUFFICIENT_AMOUNT);
        } else if (CommonFunction.removeThousandSeparators(value).length > 18) {
            return Promise.reject(LIMIT_YOUR_INPUT);
        } else if (!AMOUNT_VALIDATION.test(value)) {
            return Promise.reject(INVALID_AMOUNT);
        } else {
            return Promise.resolve();
        }

    };

    const formatAndSetAmount = (value: string, name: string) => {
        CommonFunction.toFixedMethod(name, value, form);
        form.validateFields([name]);
    }

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const name = 'transferAmount';
        if (transferFundAmount != toNumber(value)) {
            setSelectFullAmountSelected(false)
        }
        if (AMOUNT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)
        } else if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)

        }
    };

    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (AMOUNT_VALIDATION.test(value)) {
            const name = 'transferAmount';
            let amount = CommonFunction.removeThousandSeparators(value);
            amount = amount.replace('.00', "")
            form.setFieldsValue({[name]: amount});
            form.validateFields([name]);
        }
    };

    const onSubmit = (values: any) => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to transfer money?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setSpinning(true)
                let transactionTemplateDto: TransactionTemplateDto = {};
                transactionTemplateDto.backOfficeTransaction = true
                transactionTemplateDto.transactionDocumentId = uploadDocumentDetailId
                transactionTemplateDto.portfolioId = values.portfolioId
                transactionTemplateDto.fundId = values.fundId
                transactionTemplateDto.transferFundAmount = toNumber(CommonFunction.removeThousandSeparators(values.transferAmount))
                transactionTemplateDto.transferAccountType = values.accountType
                transactionTemplateDto.transferFundId = values.fundId
                transactionTemplateDto.cin = values.cin
                transactionTemplateDto.fullAmountSelection = isSelectFullAmountSelected

                if (ACCOUNT_TYPE.OWN === values.accountType) {
                    transactionTemplateDto.transferPortfolioId = values.toPortfolioId
                } else {
                    transactionTemplateDto.transferPortfolioId = toPortfolioId
                    transactionTemplateDto.transferAccountName = toPortfolioCustomerName
                }

                transactionService.transferInvestMoney(transactionTemplateDto).then((res) => {
                    if (res.data.results) {
                        message.success(MSG_TRANSFER_SUCCESS)
                        setSpinning(false)
                        setUploadedDocumentList([])
                        form.resetFields()
                        setUploadDocumentDetailId(undefined)
                        setSelectedPortfolioId(0)
                        setSelectFullAmountDisabled(true)
                        setCinDataList([])
                        setCinNumber(null)
                        setJobNumber(0)
                        setPortfolioList([])
                        setDocumentUploadMandatory(false)
                        setSummaryDataToState(res.data.results.transactionTemplateDto)
                        setCanHideSummery(false)
                    } else {
                        message.error(MSG_TRANSFER_FAILURE)
                        setSpinning(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinning(false)

                })
            },
            onCancel() {

            }
        });
    }

    const setSummaryDataToState = (data: TransactionTemplateDto) => {
        let transactionData: TransactionSummaryDto = {
            portfolio: data.portfolioNumber,
            fund: data.fundName,
            transferAccountType: ACCOUNT_TYPE.OWN === data.transferAccountType ? "Own Account" : "Other Account",
            jobNumber: jobNumber,
            documentId: data.transactionDocumentId as number,
            transferAmount: CommonFunction.currencyFormat(data.transferFundAmount),
            transferPortfolioCustomerName: data.transferAccountName,
            transferPortfolio: data.transferPortfolioNumber,
            refNumber: data.autoGeneratedRefNo,
            processingDate: data.processDate,
        };

        setSummaryData(transactionData)
    }


    const fetchCustomerName = (rule: any, value: any, callback: any) => {
        if (value) {
            setSpinning(true)
            transactionFetchService.getCustomerNameByPortfolioNumber(value, cinNumber as string).then(res => {
                if (res.data !== null) {
                    let results = res.data.results;
                    form.setFieldsValue({otherPortfolioName: results.customerName})
                    setToPortfolioId(results.id)
                    setToPortfolioCustomerName(results.customerName)
                    callback()
                } else {
                    callback(MSG_ENTER_VALID_PORTFOLIO_ID)
                }
                setSpinning(false)
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback(MSG_ENTER_VALID_PORTFOLIO_ID)
                setSpinning(false)

            })
        } else {
            callback(MSG_ENTER_PORTFOLIO_ID)
        }
    };

    const onRemove = () => {
        setSpinning(true)
        if (uploadedDocumentList) {
            documentService.deleteDocumentById(uploadedDocumentList[0].uid).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList([])
                    setUploadDocumentDetailId(undefined)
                    form.setFieldsValue({documentUpload: undefined})
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                    setSpinning(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        }

        return true;
    };

    const beforeUploadDocument = (file: any) => {
        if (null != jobNumber && jobNumber > 0) {
            return validateDocument(file, DOCUMENT_TYPES.TTD, ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES));
        }
        message.error(`Please select the CIN number before uploading the document`);
        return Upload.LIST_IGNORE;
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setSpinning(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", JSON.stringify(jobNumber));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false)
                setUploadDocumentDetailId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setSpinning(false)
            } else {
                setSpinning(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.TTD) {
            setUploadedDocumentList(defaultFileList)
            form.setFieldsValue({documentUpload: defaultFileList})

        }
    };

    const onClose = () => {
        form.resetFields();
        form.setFieldsValue({accountType: ACCOUNT_TYPE.OWN})
        setCanHideSummery(true)
        setToPortfolioDisabled(true)
        setSelectFullAmountSelected(false)
        setTransferAccountType(ACCOUNT_TYPE.OWN)
        setFundList([])
    }

    const onPreview = (documentId: string, docTypeName: string) => {
        setSpinning(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(CommonFunction.checkDocumentContentType(res.data.results))
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            setSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    // const navigateHistory = () => {
    //     window.open("/workflow/customer/transaction-history/" + "transfer-transactions", "_blank")
    // }

    const handleSearch = (searchValue: string) => {
        if (searchValue.length > 2) {
            setSpinning(true)
            transactionFetchService.customerCinSuggest(searchValue).then(res => {
                if (res.data !== null) {
                    setCinDataList(res.data.results)
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_CIN_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        }
    };

    const handleChange = (cinNumber: string) => {
        setCinNumber(cinNumber)
        fetchPortfolioList(cinNumber)
        fetchCustomerDetailsByCIN(cinNumber)
        form.resetFields(["documentUpload",
            "toPortfolioId",
            "otherPortfolioName",
            "otherToPortfolioId",
            "accountType",
            "transferAmount",
            "fullAmount",
            "fundId",
            "portfolioId"])
        setUploadedDocumentList([])
        setSelectFullAmountDisabled(true)
        setSelectFullAmountSelected(false)
        setUploadDocumentDetailId(undefined)
        form.setFieldsValue({accountType: ACCOUNT_TYPE.OWN})

    };
    return (
        <Row gutter={[40, 0]} className={'right-side-container-margin'}>
            <Col lg={10} md={10} sm={0}
                 className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                <Row>
                    <Col span={24}>
                        <div className="clip-path-img">
                            <div className='clip-path-img-container'>
                                <img src={transfer_template_img} alt="logo"/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
            {isCanHideSummery ?
                <Col lg={14} md={14} sm={24}
                     className='right-side-main-container-inside-dashboard align-div-center dashboard-right-side-contaner-scroll layout-bottom-space'>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={form}
                        onFinish={onSubmit}
                    >
                        <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                            <div>
                                <Row gutter={[32, 0]}>
                                    <Col xs={18} sm={18} md={18} lg={18} xl={18} className='page-header-main-title-col'>
                                        <h2 className='page-header-main-title'
                                            style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                            <div className='header_icon header-icon-center'>
                                                <img style={{height: 28, width: 28}}
                                                     src={transfer_title_img} alt=""/>
                                            </div>
                                            Transfer Money
                                        </h2>
                                    </Col>
                                    {/*<Col xs={6} sm={6} md={6} lg={6} xl={6} className='view-tr-history-btn-col'>*/}
                                    {/*    <Button onClick={navigateHistory}*/}
                                    {/*            size={'small'} className={'view-tr-history-btn'} icon={<HistoryOutlined />}>View History</Button>*/}

                                    {/*</Col>*/}
                                </Row>
                                <Row>
                                    <Spin size="large" tip="Loading" spinning={isSpinning}>
                                        <Col span={24}>
                                            <Card className={'template_card'} title={'Transfer From'}>
                                                <Row gutter={[32, 0]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label="CIN"
                                                            name={"cin"}
                                                            rules={
                                                                [{required: true, message: 'Please select CIN'}]}>

                                                            <Select
                                                                showSearch
                                                                // value={value}
                                                                placeholder={"Please enter at least 3 or more characters"}
                                                                style={{width: '100%'}}
                                                                listHeight={180} size={'large'}
                                                                defaultActiveFirstOption={false}
                                                                suffixIcon={null}
                                                                filterOption={false}
                                                                onSearch={handleSearch}
                                                                onChange={handleChange}
                                                                notFoundContent={null}
                                                                options={(cinDataList || []).map((d) => ({
                                                                    value: d.value,
                                                                    label: d.label,
                                                                }))}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label="Portfolio ID"
                                                            name={"portfolioId"}
                                                            rules={
                                                                [{required: true, message: 'Please select portfolio'}]}>
                                                            <Select placement='bottomLeft' listHeight={180}
                                                                    placeholder={"Select portfolio"}
                                                                    getPopupContainer={(trigger: {
                                                                        parentNode: any;
                                                                    }) => trigger.parentNode}
                                                                    style={{width: '100%'}}
                                                                    options={portfolioList}
                                                                    onChange={onChangePortfolio}
                                                                    size={'large'}
                                                            >
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label="Fund"
                                                            name={"fundId"}
                                                            rules={
                                                                [{required: true, message: 'Please select fund'}]}>
                                                            <Select placement='bottomLeft' listHeight={180}
                                                                    placeholder={"Select fund"}
                                                                    getPopupContainer={(trigger: {
                                                                        parentNode: any;
                                                                    }) => trigger.parentNode}
                                                                    style={{width: '100%'}}
                                                                    options={fundList}
                                                                    onChange={onChangeFund}
                                                                    size={'large'}
                                                            >
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label={"Full Amount"}
                                                            name={"fullAmount"}>

                                                            <Input step="0.00"
                                                                   size={'large'} disabled
                                                            />

                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Checkbox className='full_amount_checkbox'
                                                                  disabled={isSelectFullAmountDisabled}
                                                                  checked={isSelectFullAmountSelected}
                                                                  onChange={onSelectFullAmount}>
                                                            <span className="full_amount_txt">
                                                                Select the Full Amount
                                                            </span>
                                                            <Tooltip title="A full amount transfer represents the total value available on the transaction date">
                                                                <InfoCircleOutlined style={{fontSize:18, marginLeft: 10, color: '#108ee9'}}/>
                                                            </Tooltip>
                                                        </Checkbox>
                                                        <Form.Item
                                                            label={<><span className='custom-astrix'>*</span> Amount</>}
                                                            name={'transferAmount'}
                                                            // validateTrigger={["onBlur"]}
                                                            rules={[{validator: validateAmount}]}>
                                                            <Input onKeyPress={Validation.isNumber}
                                                                // maxLength={15}
                                                                   size={'large'}
                                                                   onBlur={handleBlur}
                                                                   onFocus={handleFocus}
                                                                   autoComplete="off"
                                                                   placeholder={"Enter amount"}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                        <Col span={24}>
                                            <Card className={'template_card'} title={'Transfer To'}>
                                                <Row gutter={[32, 0]}>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label={'Account Type'}
                                                            name={"accountType"}
                                                            rules={
                                                                [{
                                                                    required: true,
                                                                    message: 'Please select third party bank account details'
                                                                }]}>
                                                            <Radio.Group optionType="button"
                                                                         buttonStyle="solid"
                                                                         className='template-screen-radio-btn'
                                                                         onChange={handleTransferAccountTypeRadioChange}

                                                            >

                                                                <Radio.Button value={ACCOUNT_TYPE.OWN}><FontAwesomeIcon
                                                                    icon={faUser}
                                                                    className='radio-btn-icon'/> Own
                                                                    Account</Radio.Button>
                                                                <Radio.Button
                                                                    value={ACCOUNT_TYPE.OTHER}><FontAwesomeIcon
                                                                    icon={faBank}
                                                                    className='radio-btn-icon'/> Other
                                                                    Account</Radio.Button>

                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </Col>
                                                    {
                                                        ACCOUNT_TYPE.OTHER === transferAccountType ?
                                                            <>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item
                                                                        label={<><span
                                                                            className='custom-astrix'>*</span> Portfolio
                                                                            ID</>}
                                                                        name={'otherToPortfolioId'}
                                                                        onKeyPress={Validation.isNumberWithDash}
                                                                        validateTrigger={["onBlur"]}
                                                                        rules={[{validator: fetchCustomerName}]}
                                                                    >
                                                                        <Input size={'large'}
                                                                               placeholder={"Enter Portfolio ID"}/>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item
                                                                        label="Name"
                                                                        name={'otherPortfolioName'}
                                                                        rules={
                                                                            [{
                                                                                required: true,
                                                                                message: "Please enter name"
                                                                            }]}
                                                                    >
                                                                        <Input size={'large'} disabled/>
                                                                    </Form.Item>
                                                                </Col>
                                                            </>
                                                            :
                                                            <>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item
                                                                        label="Portfolio ID"
                                                                        name={"toPortfolioId"}
                                                                        rules={
                                                                            [{
                                                                                required: true,
                                                                                message: 'Please select portfolio'
                                                                            }]}>
                                                                        <Select placement='bottomLeft' listHeight={180}
                                                                                disabled={isToPortfolioDisabled}
                                                                                placeholder={"Select portfolio"}
                                                                                getPopupContainer={(trigger: {
                                                                                    parentNode: any;
                                                                                }) => trigger.parentNode}
                                                                                style={{width: '100%'}}
                                                                                options={portfolioList?.map((fund) => ({
                                                                                    value: fund.value,
                                                                                    label: fund.label,
                                                                                    disabled: fund.value === selectedPortfolioId,
                                                                                }))}
                                                                                onChange={onChangeToPortfolio}
                                                                                size={'large'}
                                                                        >
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            </>
                                                    }


                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Form.Item
                                                            label="Upload a Document"
                                                            name={'documentUpload'}
                                                            rules={
                                                                [{
                                                                    required: isDocumentUploadMandatory,
                                                                    message: 'Please upload a document'
                                                                }]}>
                                                            <Upload {...configs}
                                                                    className='upload_comp'
                                                                    accept={ALLOWED_IMAGE_TYPE_EXTENSION.concat(", " + ALLOWED_DOCUMENT_TYPE_EXTENSION)}
                                                                    listType="picture"
                                                                    onPreview={(e: any) => {
                                                                        onPreview(uploadedDocumentList ? uploadedDocumentList[0].uid : '',
                                                                            uploadedDocumentList ? uploadedDocumentList[0].name : '')
                                                                    }}
                                                                    onRemove={onRemove}
                                                                    fileList={uploadedDocumentList && uploadedDocumentList?.length > 0 ? uploadedDocumentList : undefined}
                                                                    beforeUpload={beforeUploadDocument}
                                                            >
                                                                {(undefined != uploadedDocumentList ? uploadedDocumentList.length : [].length) < 1 &&
                                                                    <Button>
                                                                        <div className='upload-btn-div'>
                                                                            <div className="upload-icon-div">
                                                                                <PlusOutlined
                                                                                    style={{
                                                                                        fontSize: 20,
                                                                                        color: '#757575'
                                                                                    }}/>
                                                                            </div>
                                                                            <div className="upload-btn-text-div">
                                                                <span>
                                                                    Document {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </Button>
                                                                }
                                                            </Upload>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Spin>
                                </Row>
                            </div>
                            <div>
                                <Row gutter={[32, 0]}>

                                    <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                                        <Form.Item className='form-item-btn'>
                                            {/*Redirect to the summary page*/}
                                            <Button htmlType="submit" type="primary"
                                                    disabled={isSpinning}
                                                    className='custom-btn-primary ant-btn margin_top_20'>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </Form>
                    <Modal
                        className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                        open={previewOpen}
                        centered
                        title={previewTitle}
                        onCancel={handlePreviewCancel}
                        destroyOnClose={true}
                        width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                        footer={[
                            <Button type="primary" icon={<DownloadOutlined/>}
                                    style={{background: '#FF7400', height: 40}}
                                    htmlType="submit" onClick={() => CommonFunction.download(docURL, previewTitle)}>
                                Download
                            </Button>]}>
                        <PreviewModalComp docURL={docURL}/>
                    </Modal>
                </Col> : <TransactionSummaryPage summaryData={summaryData} onClose={onClose}
                                                 summaryPageType={TRANSACTION_SUMMARY_PAGE_TYPES.TRANSFER}/>}
        </Row>
    )

}
export default TransferRequestPage;

